import React from "react";
import classNames from "classnames";
import styles from "./index.module.scss";
import { useTranslation } from "react-i18next";
import { Url } from "@/helpers/url";
import { Icon } from "@/elements-react/fix-icon";
import { FixButton } from "@/elements-react/fix-button";
import { useLayoutType, LayoutStyleTypes, LayoutTypes } from "@/util-react/layout";
import { googleEvent } from "@/helpers/google-events.ts";

const CartEmptyLabel: React.FC<{ className?: string }> = ({ className }) => {
  const { t } = useTranslation();
  const { layoutType, layoutStyleType, defaultLayoutStyleType } = useLayoutType();

  return (
    <div className={classNames(styles.root, className, styles[defaultLayoutStyleType])}>
      <div className={styles.iconWrap}>
        <Icon name="shopping-cart" className={styles.icon} />
      </div>
      <div className={styles.text}>
        <div className={styles.title}>{t("y9ht8nx7p3ni80xt.empty-label", "Your shopping cart is empty")}</div>
        <FixButton
          className={styles["button"]}
          variant={"primary"}
          href={Url.to("home-page")}
          size={"large"}
          onClick={() => googleEvent("continue_shopping_click")}
        >
          {t("e83geotgxa5m02vb.back-to-shopping", "Back to shopping")}
        </FixButton>
      </div>
    </div>
  );
};

export default CartEmptyLabel;
